import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { getLang } from 'shared/store/selectors/lang.selector';
import styles from './analyzing-step.module.scss';

export const AnalyzingStep = () => {
  const lang = useSelector(getLang('SETTINGS'));

  return (
    <div className={styles.root}>
      <FontAwesomeIcon icon={faSpinner} spin className={styles.spinner} />
      <span className={styles.label}>{lang.SHIFTS_ANALYZING}</span>
    </div>
  );
};
